<ng-template #sponsoredHeroBanner>
  <app-sponsoring-wrapper [sponsorItem]="sponsorItem" [isHeroBanner]="true">
    <section class="storyblok-blok-container">
      <div
        #wrappedComponent
        appIsVisible (isVisible)="fireViewPromoGAEvent()"
        class="banner__container"
        [ngClass]="{
    'banner__container-inverted': !isMobile && imagePosition === 'left',
    'banner__container-blue': backgroundColor === 'blue'
  }"
      >
        <div class="info__section" [ngClass]="{ 'info__section-larger': !subtext.length}">
          <header>
            <h1>{{ title }}</h1>
          </header>
          <p *ngIf="!!subtext.length" class="subtext">{{ subtext }}</p>
          <button type="button" (click)="fireSelectPromoGAEvent(); navigateTo()" *ngIf="!!button.length">{{ button[0].text }}</button>
        </div>
        <div
          [title]="image.title"
          [attr.aria-label]="image.alt"
          class="image__section"
          [style.background-image]="'url(' + (image.filename + sbFormatParam) + ')'"
          [ngClass]="{
            'image-to-left': imagePosition === 'left',
            'image-to-right': imagePosition === 'right'
          }"
        ></div>
      </div>
    </section>
  </app-sponsoring-wrapper>
</ng-template>

<ng-template #heroBanner>
  <section class="storyblok-blok-container">
    <div
      appIsVisible (isVisible)="fireViewPromoGAEvent()"
      class="banner__container"
      [ngClass]="{
        'banner__container-inverted': !isMobile && imagePosition === 'left',
        'banner__container-blue': backgroundColor === 'blue'
      }"
    >
      <div class="info__section" [ngClass]="{ 'info__section-larger': !subtext.length}">
        <header>
          <h1>{{ title }}</h1>
        </header>
        <p *ngIf="!!subtext.length" class="subtext">{{ subtext }}</p>
        <button type="button" (click)="fireSelectPromoGAEvent(); navigateTo()" *ngIf="!!button.length">{{ button[0].text }}</button>
      </div>
      <div
        [title]="image.title"
        [attr.aria-label]="image.alt"
        class="image__section"
        [style.background-image]="'url(' + (image.filename + sbFormatParam) + ')'"
        [ngClass]="{
      'image-to-left': imagePosition === 'left',
      'image-to-right': imagePosition === 'right'
    }"
      ></div>
    </div>
  </section>
</ng-template>

<ng-container *ngTemplateOutlet="sponsorItem?.isSponsored ? sponsoredHeroBanner : heroBanner"></ng-container>
